import { render } from "./CollapsibleTable.vue?vue&type=template&id=467a6c28"
import script from "./CollapsibleTable.vue?vue&type=script&lang=js"
export * from "./CollapsibleTable.vue?vue&type=script&lang=js"

import "./CollapsibleTable.vue?vue&type=style&index=0&id=467a6c28&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__